var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"move-to-fixed-bi-monthly-check-popup"},[_c('popup',{attrs:{"buttons":_vm.buttonOptions,"back-action":_vm.back},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v("כל כמה זמן ההוצאה הזו הולכת לרדת?")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }